import { useMutation } from 'react-query';

import { binderManagementFileInputAxios } from '../../binderManagement.api';
import { useHandleError } from '../../binderManagement.utils';

export const useSubmitBDX = () => {
  const handleError = useHandleError({
    file: 'binderManagement.bdx.mutation.useSubmitBDX',
    warning: 'notification.bdx.submitFail',
  });

  return useMutation(
    async ({ requestId }) => {
      const data = await binderManagementFileInputAxios.post('submit', { requestId });

      return data;
    },
    {
      onError: handleError,
    }
  );
};
